import React from 'react'
import styled from 'styled-components'

import { mediaMax } from 'styles/media'

export const Heading = styled.h4`
  font-size: ${({ theme }) => theme['-ds-font-size-xl']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-xl']['font-weight'].value};
  color: ${({ theme }) => theme.brand.jungle};
  color: ${({ theme }) => theme['-ds-core-400'].value};
  line-height: 1.2;

  ${mediaMax.md`
    font-size: ${({ theme }) => theme['-ds-font-size-md']['font-size'].value};
  `}
`

export const Text = styled.p`
  font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
  font-weight: ${({ theme }) => theme['-ds-font-size-sm']['font-weight'].value};
  color: ${({ theme }) => theme['-ds-core-300'].value};
  line-height: 1.7;

  ${mediaMax.md`
      font-size: ${({ theme }) => theme['-ds-font-size-xs']['font-size'].value};
    `}
`

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 30px;
  max-width: 485px;

  ${mediaMax.md`
    padding: 0;
  `}
`

type InfoParagraphProps = {
  heading: React.ReactNode
  text: React.ReactNode
}

const InfoParagraph: React.FC<InfoParagraphProps> = ({ heading, text }) => {
  return (
    <Inner>
      <Heading>{heading}</Heading>
      <Text>{text}</Text>
    </Inner>
  )
}

export default InfoParagraph
